import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "./style/where.css";

const Where = () => {
	return (
		<div style={{ textAlign: "center", padding: 30 }}>
			<div className="where-paragraph">
				<p className="where-text">
					Take an appointment and visit our Showroom in Milan to discover all
					creations:
				</p>
				<a
					href="https://wa.me/393483512992"
					className="icon-link"
					target="_blank"
					rel="noreferrer"
				>
					<FontAwesomeIcon icon={faWhatsapp} className="icon" />
				</a>
			</div>
			<div className="responsive-iframe">
				<iframe
					src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2798.375162528569!2d9.18572107672458!3d45.46224603356855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4786c6abe4da27f3%3A0xd40186a526f5eb5d!2sVia%20Giuseppe%20Mazzini%2C%2016%2C%2020123%20Milano%20MI!5e0!3m2!1sen!2sit!4v1702897461317!5m2!1sen!2sit"
					width="100%"
					height="550"
					style={{ border: "0", paddingTop: 20 }}
					allowFullScreen
					loading="lazy"
					//referrerpolicy="no-referrer-when-downgrade"
				></iframe>
			</div>
		</div>
	);
};

export default Where;
